export type ClaimsIncident = {
  incident: string;
  action: string;
  conditions: string;
};

export const claimsIncidents: ClaimsIncident[] = [
  {
    incident: 'Producto en mal estado',
    action: 'Comunicar la incidencia y adjuntar fotografías.',
    conditions: 'Comunicar de inmediato. Plazo máximo: 60 días desde la entrega (art. 342 del Código de Comercio).'
  },
  {
    incident: 'Caducidad',
    action: 'Reclamar solo si existe un defecto de fabricación o si la caducidad es inferior a 2 meses.',
    conditions: 'Comunicar de inmediato.'
  },
  {
    incident: 'Cantidades o referencias incorrectas',
    action: 'Regularización de factura o recogida y abono.',
    conditions: 'Comunicar de inmediato.'
  },
  {
    incident: 'Error del cliente',
    action: 'Enviar la mercancía a nuestras instalaciones o entregarla en un Cash.',
    conditions: 'Gastos de transporte a cargo del cliente.'
  },
  {
    incident: 'Roturas (transporte propio)',
    action: 'Durante la descarga, entregar la mercancía al conductor. Después de la descarga, comunicar la incidencia y adjuntar fotografías.',
    conditions: 'Plazo máximo: 72 horas desde la entrega.'
  },
  {
    incident: 'Recogidas',
    action: 'Solo con autorización del comercial.',
    conditions: 'El transportista no recogerá mercancía sin autorización.'
  }
];

export const claimsReminders = [
  'Adjuntar fotografías siempre que sea necesario.',
  'Respetar los plazos.',
  'Sin autorización del comercial no se realizan recogidas.'
];

export const claimsClosingText =
  'Agradecemos su colaboración. El cumplimiento de estas condiciones nos permitirá gestionar las incidencias de forma más rápida y eficiente, ofreciendo un mejor servicio a todos nuestros clientes.';

export const claimsContactText =
  'Cualquier reclamación que el USUARIO considere oportuna será atendida a la mayor brevedad posible. Puede realizarse escribiendo a info@jaradpetfood.com o contactando con su comercial asignado.';

export const claimsFaqAnswer = [
  'Para gestionar una incidencia o devolución, consulta las siguientes condiciones:',
  '',
  ...claimsIncidents.flatMap(({ incident, action, conditions }) => [
    incident,
    `Qué hacer: ${action}`,
    `Plazo / condiciones: ${conditions}`,
    ''
  ]),
  'Recordatorio:',
  ...claimsReminders.map((reminder) => `• ${reminder}`),
  '',
  claimsClosingText,
  '',
  claimsContactText
].join('\n');
